import { CashAdvanceLimitType } from '@lib/enums';

export enum AccountType {
    PREPAID = 'PREPAID',
    COLLATERAL = 'COLLATERAL',
    CREDIT = 'CREDIT',
    SECURITY = 'SECURITY',
    MASTER = 'MASTER',
}

export enum AccountStatus {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    TERMINATED = 'TERMINATED',
}

export enum FundType {
    INITIAL_LOAD_FUNDS = 'initialLoadFunds',
    LOAD_FUNDS = 'loadFunds',
    UNLOAD_FUNDS = 'unloadFunds',
    TRANSFERS = 'transfers',
    REFUND = 'refund',
}
export enum SettingType {
    LOGO = 'logo',
    EXCHANGE_RATE = 'exchange_rate',
    MOBILE_APP = 'mobileApp',
}

export enum AllowedLoadType {
    LOAD = 'LOAD',
    INITIAL_LOAD = 'INITIAL_LOAD',
}

export interface IAccount {
    id: string;
    user_id: string;
    card_product_id: string;
    type: AccountType;
    balances: IBalance;
    ledger_balances: IBalance;
    status: string;
    created: string;
    modified: string;
    default_account: boolean;
    currencies: string[];
    wallet_details: IWallet[];
    credit_limits: IAccountCreditLimits;
}

export interface IAccountCreditLimits {
    statement_date: number;
    assigned_credit_limit: number;
    cash_advance: IAccountCardCashAdvance;
}

export interface IAccountCardCashAdvance {
    cash_adv_limit_type: CashAdvanceLimitType;
    cash_adv_limit_value: number;
}

export interface IWallet {
    currency: string;
    priority: number;
    status: string;
    allowed_load_type: AllowedLoadType;
}

export interface IBalance {
    [key: string]: number;
}

export interface ILinkAccountCard {
    accountId: string;
    ids: string[];
    dry_run: boolean;
}

export interface IAccountFunds {
    amount: number;
    currency: string;
    note: string;
    dry_run: boolean;
}
export interface ITransferAmount {
    amount: number;
    fromCurrency: string;
}

export interface IAccountFundsResponse {
    transaction_id: string;
    account_id: string;
    request: {
        currency: string;
        amount: number;
        note: string;
        dry_run: boolean;
    };
    result: {
        fee_amount: number;
        status: string;
        status_reason: string;
        status_description: string;
    };
    created: string;
    modified: string;
}

export interface ICreateAccount extends Pick<IAccount, 'user_id' | 'card_product_id' | 'type' | 'currencies'> {
    credit_limits: {
        assigned_credit_limit: number;
        cash_adv_limit_type: 'FIXED' | 'PERCENTAGE';
        cash_adv_limit_value: number;
    };
}
